import React from 'react'
import * as Highcharts from 'highcharts'

export interface Props {
  readonly options: Highcharts.Options
  readonly testId?: string
  readonly defaultOptions?: boolean
}

export class Chart extends React.Component<Props> {
  private chart: Highcharts.Chart
  private chartRef: HTMLDivElement

  public constructor(props) {
    super(props)

    const { defaultOptions = true } = props

    if (defaultOptions) {
      Highcharts.setOptions(getDefaultChartOptions())
    }
  }

  public componentDidMount() {
    const { options } = this.props
    this.renderChart(options)
  }

  public shouldComponentUpdate(nextProps: Props) {
    const { options } = this.props
    const { options: nextOptions } = nextProps

    if (options === nextOptions) {
      return true
    }

    this.renderChart(nextOptions)
    return false
  }

  public componentWillUnmount() {
    this.chart.destroy()
  }

  public render() {
    const { testId } = this.props
    return (
      <div
        data-e2e={testId}
        data-testid={testId}
        ref={(chartRef: HTMLDivElement) => (this.chartRef = chartRef)}
      />
    )
  }

  private renderChart = (options: Highcharts.Options) => {
    if (this.chart) {
      this.chart.destroy()
    }

    const chartConfig = options.chart

    this.chart = Highcharts.chart({
      ...options,
      chart: {
        ...chartConfig,
        renderTo: this.chartRef
      }
    })

    this.chart.redraw()
  }
}

const getDefaultChartOptions = (): Highcharts.Options => ({
  credits: {
    enabled: false
  },
  exporting: {
    enabled: false
  },
  legend: {
    enabled: false
  },
  title: {
    text: undefined
  },
  chart: {
    backgroundColor: undefined
  },
  loading: {
    labelStyle: {
      color: 'transparent'
    },
    style: {
      backgroundColor: 'transparent'
    }
  },
  yAxis: {
    gridLineColor: 'transparent',
    labels: {
      enabled: true
    },
    title: {
      text: undefined
    }
  }
})
